import { useId } from "react";
import { Tooltip } from "react-tooltip";
import SVG from "./SVG";
import { formatLeverage } from "../helper/formatLeverage";

const validLeverages = (values) => {
  if (!Array.isArray(values)) return [];
  return [...new Set(values.map(Number))].filter(
    (value) => Number.isFinite(value) && value > 0,
  );
};

export default function LeverageModeDisplay({
  mode,
  fixedLeverage,
  allowedLeverages,
  values,
  showInfoButton = false,
}) {
  const reactId = useId();
  const tooltipId = `leverage-mode-${reactId.replace(/:/g, "")}`;
  const isSelectable = mode === "selectable";
  const isFixed = mode === "fixed";

  if (!isSelectable && !isFixed) return "-";

  const tooltipValues = validLeverages(
    values ?? (isSelectable ? allowedLeverages : [fixedLeverage]),
  );

  return (
    <span dir="rtl" className="inline-flex items-center gap-2">
      <span
        data-tooltip-id={tooltipId}
        tabIndex={showInfoButton ? undefined : 0}
        className={showInfoButton ? undefined : "cursor-help"}
      >
        {isSelectable ? "متغیر" : "ثابت"}
      </span>
      {showInfoButton && (
        <button
          type="button"
          data-tooltip-id={tooltipId}
          aria-label="نمایش مقادیر اهرم"
          className="flex items-center gap-1.5 bg-zi-inputbg-dark px-2 py-1 rounded-md"
        >
          <SVG
            name="infoCircle"
            classname="stroke-zi-text-light fill-zi-text-light dark:stroke-zi-text-dark dark:fill-zi-text-dark"
          />
          <span className="hidden sm:inline text-zi-text-light/70 dark:text-zi-text-dark/80 text-sm font-light">
            توضیحات
          </span>
        </button>
      )}
      <Tooltip
        id={tooltipId}
        place="bottom"
        opacity={1}
        openEvents={{ mouseover: true, focus: true, click: true }}
        closeEvents={{ mouseout: true, blur: true }}
        globalCloseEvents={{ clickOutsideAnchor: true, escape: true }}
        className="z-50 !w-64 !max-w-[calc(100vw-2rem)] !p-3 !bg-zi-blue-dark !rounded-lg"
        render={() => (
          <div dir="rtl" className="flex flex-col gap-2">
            <span className="text-sm font-medium">
              {isSelectable ? "اهرم‌های مجاز" : "اهرم ثابت"}
            </span>
            <div className="grid grid-cols-3 gap-1.5" dir="ltr">
              {tooltipValues.length ? (
                tooltipValues.map((value) => (
                  <span
                    key={value}
                    className="rounded-md bg-white/10 px-2 py-1 text-center text-xs font-light"
                  >
                    {formatLeverage(value)}
                  </span>
                ))
              ) : (
                <span className="col-span-3 text-center text-xs font-light">-</span>
              )}
            </div>
          </div>
        )}
      />
    </span>
  );
}
